import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return {
      connections: data,
      connection_id: null,
      patient_id: props.patientId,
      app_name: props.appName,
    }
  }, [data, props.patientId, props.appName])
}
